// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Fkkd","row":"ProcedureTreatmentSummary_row__2LWBA"};